export default "__VITE_ASSET__6c62a9e6__"